import React, { Fragment }  from 'react';
import { Container }  from 'react-bootstrap';
import HeaderLogged from '../../../../../components/header_logged'
import FormEdit from '../../../../../components/auth/saude/remume/listar/form_edit'
import Head from '../../../../../components/head'


function EditarRemumeSaudeScreen () {
    return (
        <Fragment>
            <Head titulo="Editando Medicamento Essencial" />
            <HeaderLogged />
            <Container>
                <FormEdit />
            </Container>
        </Fragment>
    );
}

export default EditarRemumeSaudeScreen;